import React from "react";
import { motion } from "framer-motion";

const HomeHero = ({ hero, inView, heroRef, i18n }) => {
    const lang = i18n?.language === "ar" ? "ar" : "en";
    const title = hero.title ?? (lang === "ar" ? (hero.titleAr ?? hero.lang?.title ?? "") : (hero.titleEn ?? hero.lang?.title ?? ""));
    const description = hero.description ?? (lang === "ar" ? (hero.descriptionAr ?? hero.lang?.description ?? "") : (hero.descriptionEn ?? hero.lang?.description ?? ""));
    const btn = hero.btn ?? (lang === "ar" ? (hero.btnAr ?? hero.lang?.btn_text ?? "") : (hero.btnEn ?? hero.lang?.btn_text ?? ""));
    const background = hero.background || "";
    const logo = hero.logo || "";
    const color1 = hero.color1 || "#078AB8";
    const color2 = hero.color2 || "#31B761";

    return (
        <div className="hero-wrapper position-relative">
            <section
                ref={heroRef}
                className="hero-image d-flex align-items-center position-relative"
                style={{
                    backgroundImage: `url(${background})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    minHeight: "70vh",
                    overflow: "hidden",
                }}
            >
                <div
                    className="position-absolute w-100 h-100"
                    style={{
                        top: 0,
                        left: 0,
                        background: `linear-gradient(135deg, ${color1}CC, ${color2}CC)`,
                        zIndex: 1,
                    }}
                ></div>

                <div className="container position-relative z-2">
                    <div className="row align-items-center h-100">
                        <div className="col-lg-6 col-md-6 col-12">
                            <motion.h1
                                className="text-light mainHeading fs-2"
                                initial={{ opacity: 0, x: -50 }}
                                animate={inView ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 1, delay: 0 }}
                                // style={{ direction: lang === "ar" ? "ltr" : "ltr", textAlign: lang === "ar" ? "right" : "left" }}
                            >
                                {title}
                            </motion.h1>
                            <motion.p
                                className="paraHero"
                                initial={{ opacity: 0, x: -50 }}
                                animate={inView ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 1, delay: 0.25 }}
                                // style={{ direction: lang === "ar" ? "ltr" : "ltr", textAlign: lang === "ar" ? "right" : "left" }}
                            >
                                {description}
                            </motion.p>
                            <motion.button
                                className="hero-button"
                                initial={{ opacity: 0, x: -50 }}
                                animate={inView ? { opacity: 1, x: 0 } : {}}
                                transition={{ duration: 1, delay: 0.5 }}
                                onClick={() => (window.location.href = "contact-us")}
                            >
                                {btn}
                            </motion.button>
                        </div>

                        <div className="col-lg-6 col-md-6 col-12 text-center">
                            <motion.img
                                src={logo}
                                alt="logo"
                                width={180}
                                initial={{ opacity: 1, y: 40 }}
                                animate={inView ? { opacity: 1, y: [0, -10, 0] } : { opacity: 0 }}
                                transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                            />
                        </div>
                    </div>
                </div>
            </section>

            <div className="hero-decoration">
                <img src={require("../Images/Group 20.png")} width={70} alt="Decoration" />
            </div>
        </div>
    );
};

export default HomeHero;
